import { ChevronLeft } from "@/assets/icons/mdi-chevron-left";
import Link from "next/link";

export const BackToSelection = () => (
  <div className="flex justify-start bg-secondary ph:justify-center">
    <Link href="/blog-evenements" className="text-base font-light text-primary">
      <div className="flex items-center gap-1">
        <ChevronLeft className="h-5 w-5" />
        <span className="underlineEffect transition-colors duration-300">
          Retour à l&apos;accueil
        </span>
      </div>
    </Link>
  </div>
);
